import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { FirmaElectronicaService } from 'app/services/firma-electronica/firma-electronica.service';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-listado-pagare',
  templateUrl: './listado-pagare.component.html',
  styleUrls: ['./listado-pagare.component.scss']
})
export class ListadoPagareComponent implements OnInit {
  user : any; 
  pagares : any = [];
  loading:boolean;
  adjuntarPDF: boolean;
  dataEnviar: any = {};  
  dataEnviarKeynua:any = {};
  fechaIni : any = 0;
  fechaFin : any = 0;
  dataFiltro : FormGroup;
  rucProvFilter = new FormControl('');
  tipoServicioElement : any = 0;
  filterValues = {
    Tipo_Servicio_Dsc: '',
    Proveedor:''
    };  
  dataSource =new MatTableDataSource( this.pagares); 
  tipoCMFilter = new FormControl('');
  constructor(private empresaservice : EmpresasService,
    private firmaElectronicaService:FirmaElectronicaService,private datePipe: DatePipe) { 
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.dataFiltro = new FormGroup({
      "Fecha_Inicio": new FormControl(''),
      "Fecha_Fin": new FormControl(''),
      "Tipo":new FormControl('')
    });
  }
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns: string[] = 
  ['checked','idPagare', 'Raz_Social','TipoPagare','Fecha_Inicio','Fecha_Final','Estado','Adjunto_PDF','Adjunto_PDF_Firmado'];

  ngOnInit() {
    this.empresaservice.pagareDatos = "";
    this.ListadoPagare();

    this.rucProvFilter.valueChanges
    .subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.tipoCMFilter.valueChanges
      .subscribe(
        Tipo_Servicio_Dsc => {
          this.filterValues.Tipo_Servicio_Dsc = Tipo_Servicio_Dsc;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

  }

  createFilter(): (data: any, filter: string) => boolean {
    return  function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.RazonSocialEmpresa.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1
      && data.Tipo_Pagare.toString().toLowerCase().indexOf(searchTerms.Tipo_Servicio_Dsc) !== -1;
    }

  }
  
  ListadoPagare(){
    this.fechaIni = this.datePipe.transform(this.dataFiltro.controls['Fecha_Inicio'].value,'yyyy-MM-dd');    
    this.fechaFin = this.datePipe.transform(this.dataFiltro.controls['Fecha_Fin'].value,'yyyy-MM-dd');
    if(!this.fechaIni){
      this.fechaIni = 0
    }
    if(!this.fechaFin){
      this.fechaFin = 0
    }
    this.loading = true;
    this.empresaservice.ListadoPagares(0,this.tipoServicioElement,this.fechaIni,this.fechaFin).subscribe(
      res=>{
        this.pagares = res;   
        this.pagares =  this.pagares.filter(
          state => state.RazonSocialEmpresa != null
        );
        this.dataSource = new MatTableDataSource(this.pagares);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      }, err=>{
        Swal.fire({
          title:"!Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false
        });
       this.loading = false;   
    }
      )
  }
  
  tipoServicio(event){
    this.tipoServicioElement = event;
  }

  altaPagare(element:any){
    this.adjuntarPDF = true;
    this.empresaservice.dataPagare = element;  
  }
  cerrarPopUpFirmado(){
    this.adjuntarPDF = false;
   }
  BajaPagare(id: any, estado :any) {
    this.loading = true;

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-i-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: '¿Estás seguro de dar de baja este Pagaré?',
      text: '',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      reverseButtons: true,
      heightAuto: false
    })
      .then((result) => {
        this.loading = true;
        if (result.value) {
          this.dataEnviar.idPagare = id;
          this.dataEnviar.Estado = "B";
          this.empresaservice.BajaPagare(this.dataEnviar)
            .subscribe(res => {
              this.loading = false;
              swalWithBootstrapButtons.fire({
                title: 'Exito!',
                text:'Pagare fue dado de baja con exito',
                type: 'success',
                heightAuto: false
            })
              .then(resp => {
                if (resp.value == true) {
                  this.ListadoPagare();
                }
              });
            }, (err: HttpErrorResponse) => {
              this.loading = false;
              swalWithBootstrapButtons.fire({
                title: "Ha ocurrido un error",
                text: err.error.id,
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              } );            
            })
        } else if (          
          result.dismiss === Swal.DismissReason.cancel          
        ) {
          this.loading = false
        }else{
          this.loading = false
        }
      }
      )
  }

  enviarContratoKeynua(idPagare :any){
    Swal.fire({
      title: 'Enviar Pagare a Keynua',
      text: '¿Desea enviar contrato digital a keynua.?',
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviarKeynua.idPagare = idPagare;
        this.enviarPagareElectronico(this.dataEnviarKeynua);
      }else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    });
  }

  enviarPagareElectronico(dataEnviarKeynua){

   Swal.fire({
    title: 'Espere',
    text: 'Enviando Pagare a keynua.',
    type: 'info',
    heightAuto: false
   });
  Swal.showLoading();
   this.firmaElectronicaService.enviarPagareElectronico(dataEnviarKeynua).subscribe(
       res => {  
        Swal.close();     
         this.showNotification('success','top','right','Pagare enviado a traves de firma digital.');
       },err => {
         let error = "";
         error = err.error.error;
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + error);
       }
   );
  }
  
  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
